export default "__VITE_ASSET__0bb9b7e7__"